export enum State {
    Earth,
    Traversing,
    Waiting,
    WaitingInteractively,
}

export default State;
